import React from "react";
import { Layout } from "../../layout/Layout.js";
import { EntryForm } from "./EntryForm.js";
import { useParameter } from "../../../../packages/router/params/useParameter.js";
import { useLoadEffect } from "../../../../react/load/useLoadEffect.js";
import { getEntry } from "../accountingApi.js";
import { EntryAction } from "./EntryAction.js";

/**
 * Shows the entry form page.
 */
export const EditPage = () => {
  const entryId = useParameter("entryId");
  const copyFromEntryId = useParameter("copyFromEntryId");

  const result = useLoadEffect(`edit-entry-${copyFromEntryId}-${entryId}`, async () => {
    const action: EntryAction = copyFromEntryId
      ? { type: "copy", entry: await getEntry(copyFromEntryId) }
      : entryId
      ? { type: "update", entry: await getEntry(entryId) }
      : { type: "new" };
    return action;
  });

  const title = copyFromEntryId ? "Sisestuse kopeerimine" : entryId ? "Sisestuse muutmine" : "Uus sisestus";

  return (
    <Layout title={title} containerWidth="fixed-wide-min">
      {result.state === "success" && <EntryForm action={result.data} />}
    </Layout>
  );
};
